module.exports = __webpack_public_path__ + "images/fa-solid-900.601eb47a1dd75cb133dd8be8f8e5510f.svg";